'use client';
import React from 'react';
import { useTranslations } from 'next-intl';
// import VideoModal from '@/components/shared/VideoModal'; Please delete the file if not used
import { ActiveSubscription } from '@/lib/types/customer/restaurant/ActiveSubscription';
import If from '@ui/If';
import NotAvailableCard from '@/shared/NotAvailableCard';
import ReactPlayer from 'react-player/lazy';

type Props = {
  video: string | null | undefined;
  activeSubscription: ActiveSubscription;
};

export default function StoreVideo({ video, activeSubscription }: Props) {
  const t = useTranslations('');
  if (!video) {
    return null;
  }
  return (
    <section className="">
      <div className="pb-10">
        <div className="mb-6">
          <h3 className="text-h3 font-[900] leading-[140%] text-title">
            {t('storefront.store_profile.video')}
          </h3>
        </div>
        <If condition={video} fallback={<NotAvailableCard />}>
          <div className="relative pt-[56.25%]">
            {video && (
              <ReactPlayer
                url={video}
                height="100%"
                width="100%"
                className="absolute left-0 top-0"
              />
            )}
          </div>
        </If>
      </div>
    </section>
  );
}
